import axios from "axios";
import { serverResponse } from "../util/fakeServer";

// const url = "http://localhost:3005/";
const url = "https://viewmanager.interattivo.net/api/products/";

const API = axios.create({
  baseURL: url,
  validateStatus: function(status) {
    return status < 300;
  }
});

API.interceptors.request.use(
  (req) => {
    req.headers.clientId = `${serverResponse.config.client_id}`;
    req.headers.signboardId = `${serverResponse.config.signboard_id}`;
    // req.headers.leafletId = `${serverResponse.leaflet.id}`;
    return req;
  },
  (err) => Promise.reject(err)
);

// const clientId = serverResponse.config.client_id;
// const leafletId = serverResponse.leaflet.id;

export const getProductsSearchbar = (data) => API.post("search-products", data);
